import { render } from "./ModalAddEditReminder.vue?vue&type=template&id=5334995c"
import script from "./ModalAddEditReminder.vue?vue&type=script&lang=js"
export * from "./ModalAddEditReminder.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__